var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  